
(function () {
  var script = document.currentScript;

  // Shoplift A/B: this runs inline, before paint, so the control must bail out here or it would
  // clear the pre-selected size and lock Add to cart for everyone. If Shoplift resolves variant B
  // after first paint, variant-steps.js picks it up on the tlc:selector-ab event instead.
  if (!document.documentElement.classList.contains("tlc-selector-b")) return;

  var picker = script.closest("variant-picker");
  if (!picker) return;

  // complementary-products.js re-runs this script inside its quick-view dialog, for a picker it has
  // stripped this attribute from. variant-steps.js never tracks that picker, so clearing its size
  // here could not be undone - and the lock below would land on the page's own button instead.
  if (picker.getAttribute("data-template-product-match") !== "true") return;

  var stepsRoot = picker.querySelector("[data-variant-steps]");
  if (!stepsRoot) return;

  var steps = stepsRoot.querySelectorAll("[data-variant-step]:not([data-variant-step-static])");
  if (steps.length === 0) return;

  steps.forEach(function (step) {
    var name = step.getAttribute("data-variant-step-name");
    if (!name) return;

    var fieldset = picker.querySelector('[data-option-name="' + CSS.escape(name) + '"]');
    var checked = fieldset && fieldset.querySelector('input[type="radio"]:checked');
    if (checked) checked.checked = false;
  });

  var firstStep = steps[0];
  if (!firstStep) return;

  var pickerEl = picker;
  var firstStepEl = firstStep;

  var lockButton = function () {
    var section = pickerEl.closest(".shopify-section");
    var button = section && section.querySelector('product-form-component [ref="addToCartButton"]');
    if (!button) return;

    button.classList.add("variant-steps-locked");
    button.setAttribute("aria-disabled", "true");

    var label = button.querySelector(".add-to-cart-text__label") || button.querySelector(".add-to-cart-text__content > span");
    var optionLabel = (firstStepEl.getAttribute("data-variant-step-label") || "an option").toLowerCase();
    if (label) label.textContent = "Choose " + optionLabel;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", lockButton);
  } else {
    lockButton();
  }
})();
